import { configureStore } from '@reduxjs/toolkit'
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist'
import storage from 'redux-persist/es/storage/session'
import reducer from './index'
import { baseApi } from '../features/api/baseApi'
import { setAuthToken } from '../api'

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['auth', 'uiShell'],
}

const persistedReducer = persistReducer(persistConfig, reducer)

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).concat(baseApi.middleware),
})

store.subscribe(() => {
  const token = store.getState().auth?.token ?? null
  setAuthToken(token)
})

export const persistor = persistStore(store)
